import { render, staticRenderFns } from "./CpuFrequencyChart.vue?vue&type=template&id=95377634&scoped=true&"
import script from "./CpuFrequencyChart.vue?vue&type=script&lang=js&"
export * from "./CpuFrequencyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95377634",
  null
  
)

export default component.exports